import { render, staticRenderFns } from "./psuServicepayForm.vue?vue&type=template&id=67834183&scoped=true"
import script from "./psuServicepayForm.vue?vue&type=script&lang=js"
export * from "./psuServicepayForm.vue?vue&type=script&lang=js"
import style0 from "./psuServicepayForm.vue?vue&type=style&index=0&id=67834183&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67834183",
  null
  
)

export default component.exports